// Currency utility functions for Tanzanian Shilling (TZS)

export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return 'TZS 0';
  
  const number = parseFloat(amount);
  if (isNaN(number)) return 'TZS 0';
  
  // Format with commas and no decimal places (TZS typically doesn't use decimals)
  return `TZS ${number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })}`;
};

export const parseCurrency = (currencyString) => {
  if (!currencyString) return 0;
  
  // Remove TZS prefix and commas, then convert to number
  const cleaned = currencyString.toString().replace(/TZS\s?|,/g, '');
  const number = parseFloat(cleaned);
  return isNaN(number) ? 0 : number;
};

export const formatCurrencyInput = (value) => {
  if (!value) return '';
  
  // Remove non-digits
  const digits = value.toString().replace(/\D/g, '');
  if (!digits) return '';
  
  // Add commas
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
